import React, { ComponentProps } from "react";

import * as S from "./styles";

interface Props extends ComponentProps<any> {
  message: string;
  time: string;
}

export const MessageLeft: React.FC<Props> = ({ message, time, ...rest }) => {
  return (
    <S.Container {...rest}>
      <S.Balloon dangerouslySetInnerHTML={{ __html: message }} />
      <S.Time>{time}</S.Time>
    </S.Container>
  );
};
